<template>
  <div class="d-flex flex-column full-height main-content">
    <nav-bar @toggle-sidebar="sidebarOpen = !sidebarOpen" />
    <div class="container-fluid flex-grow-1">
      <div class="row full-height-lg">
        <router-view name="sidebar" :sidebarOpen="sidebarOpen" @close-sidebar="sidebarOpen = false"/>
        <div class="px-0 px-lg-2 push-down col-10" id="mix-list-container">
          <router-view />
        </div>
      </div>
      <player-footer />
    </div>
  </div>
</template>
<style scoped>
  #mix-list-container {
    flex: none;
    width: 100%
  }

  @media(min-width: 992px) {
    #mix-list-container {
      flex: none;
      width: 83.3333%
    }
  }

  .no-sidebar #mix-list-container {
    width: 100%
  }
</style>

<script>
import NavBar from "./nav_bar.vue"
import Sidebar from "./sidebar.vue"
import PlayerFooter from "./footer.vue"

export default {
  data() {
    return { sidebarOpen: false }
  },
  components: {
    NavBar,
    Sidebar,
    PlayerFooter,
  },
  computed: {
    loggedIn() {
      return window.mmmGlobals?.logged_in || false
    },
  },
}
</script>
